import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom"
import {useTranslation} from "react-i18next";
import useFetch, {CachePolicies} from "use-http";
import {LoadingOutlined} from "@ant-design/icons";
import {Button, Spin, Tooltip} from "antd";

import cardStyles from "./cardGroup.module.scss";
import {APIEndpoint} from "src/service/group.service";
import {getUrlHttp} from "src/service/util.service";
import {pathRoutes} from "src/props/util.props";
import earth_grid_symbol from "src/assets/png/earth_grid_symbol.png";

interface GroupCardProps {
  image: string;
  member: any;
  favorite: boolean;
  groupName: string;
  joined: boolean;
  groupID: string;
  onRefresh: any;
  group: any;
  isChat: boolean;
}

const GroupCard: React.FC<GroupCardProps> = ({
  image,
  member,
  favorite,
  groupName,
  joined,
  groupID,
  onRefresh,
  group,
  isChat
}) => {

  let text = group.mainType === "community" ? "Open" : "Chat";;
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isChatValue, setIsChatValue] = useState(false);
  const buttonText = text;
  const { t } = useTranslation();

  const api = useFetch(window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL, {
    cachePolicy: CachePolicies.NO_CACHE,
  });

  const handleClick = async () => {
    setIsLoading(true);
    if (!joined) {
      await api.post(APIEndpoint.request, { groupID: groupID });
      if (api.response.ok) {
        setTimeout(() => {
          navigate(pathRoutes.Chat + "?id=" + groupID);
          onRefresh?.();
        }, 500);
      }
    } else {
      if (buttonText === "Chat") {
        setTimeout(() => {
          navigate(pathRoutes.Chat + "?id=" + groupID);
        }, 1000);
      } else {
        setTimeout(() => {
          navigate(`${pathRoutes.groupCommunity}/${groupID}`, {
            state: { groupProps: group },
          });
          onRefresh?.();
        }, 1000);
      }
    }
  };

  const checkCommunity = () => {
    if (group?.mainType === "community") {
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    let url = window.location.href;
    if (url.indexOf("/center-chat") !== -1) {
      setIsChatValue(true)
    } else {
      setIsChatValue(false)
    }
  }, [])
  return (
    <div
      className={cardStyles.card}
      style={{
        backgroundImage: `url(${getUrlHttp(image)})`,
        backgroundSize: "cover",
        backgroundPosition:"center center"
      }}
    >
      {checkCommunity() && (
        <div className={isChatValue ? cardStyles.boxGroupChat : cardStyles.boxGroup}>
          <img src={earth_grid_symbol} width={17} height={17} ></img>
        </div>
      )}

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
        }}
      >
        {/* HideNotComplete*/}
        {/*{favorite ? (*/}
        {/*  <HeartFilled className={cardStyles.heartIcon} />*/}
        {/*) : (*/}
        {/*  <HeartOutlined className={cardStyles.heartIcon} />*/}
        {/*)}*/}
      </div>

      <div style={{ display: "flex", flexDirection: "column" }}>

        <div
          style={{
            display: "flex",
            backgroundColor: "#0000007a",
            borderRadius: "0.55rem",
            padding: "0.5rem",
          }}
        >
          <div
            style={{
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap"
            }}
          >
            <Tooltip placement="topLeft" title={groupName} color="#0f4c82">
              <div className={cardStyles.headCardDetail}>{groupName}</div>
            </Tooltip>
            {member !== null ? (
              <div className={cardStyles.cardDetail}>{`(${member} people)`}</div>
            ) : (
              <div></div>
            )}
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "flex-end",
              // justifyContent: "space-between",
            }}
          >
            <Button className={cardStyles.chatButton} onClick={handleClick}>
              {!isLoading ? (
                t(buttonText)
              ) : (
                <Spin
                  indicator={<LoadingOutlined style={{ fontSize: "20px" }} />}
                />
              )}
            </Button>
          </div>
        </div>

      </div>
    </div>
  );
};

export default GroupCard;
